import CIcon from '@coreui/icons-react'
import { cilArrowRight, cilExternalLink } from '@coreui/icons'
import type { ResearchOutput } from '../../api/types'
import { formatDate } from '../../utils/format'

export function ResearchCard({ item }: { item: ResearchOutput }) {
  return (
    <article className="research-card">
      <div className="research-card__top">
        <span className="category">{item.type}</span>
        {item.projectAlias && <code>{item.projectAlias}</code>}
      </div>
      <h3>{item.title}</h3>
      <p>{item.summary}</p>
      <div className="research-card__authors">{item.authors.join(', ')}</div>
      <div className="research-card__bottom">
        <span>
          {item.venue ?? 'LARICE output'}
          {item.publishedAt ? ` · ${formatDate(item.publishedAt)}` : ''}
        </span>
        {item.url ? (
          <a href={item.url} target="_blank" rel="noreferrer">
            Open output <CIcon icon={cilExternalLink} />
          </a>
        ) : (
          <span>
            Record only <CIcon icon={cilArrowRight} />
          </span>
        )}
      </div>
    </article>
  )
}
